export default "__VITE_ASSET__C7NQx8Yk__"